import React from 'react';

export interface IconAvatarProps {
  children: React.ReactNode;
  className?: string;
  size?: string;
  sizeStyles?: string;
  backgroundColor?: string;
}

export const IconAvatar = ({
  children,
  className,
  sizeStyles,
  backgroundColor,
  ...rest
}: IconAvatarProps) => {
  return (
    <div
      style={{ backgroundColor: backgroundColor }}
      className={`${sizeStyles}  rounded-full bg-thryv-gray-light-400 inline-flex justify-center items-center ${
        className || ''
      } `}
      {...rest}
    >
      {children}
    </div>
  );
};
